import { diagramActionTypes } from './diagram.types';

export const changeCursor = () => ({
    type: diagramActionTypes.CHANGE_CURSOR,
});

// =1==HISTORY=================================
export const historyUndo = (data) => ({
    type: diagramActionTypes.HISTORY_UNDO,
    payload: {
        ...data,
    },
});
export const historyRedo = (data) => ({
    type: diagramActionTypes.HISTORY_REDO,
    payload: {
        ...data,
    },
});
// --------------------------------------------------------------

export const updateFocusedInsideElement = (
    tableId,
    columnId,
    columnIndex,
    insideElementType
) => ({
    type: diagramActionTypes.UPDATE_FOCUSED_INSIDE_ELEMENT,
    payload: { tableId, columnId, columnIndex, insideElementType },
});

export const updateFocusedIds = (ids) => ({
    type: diagramActionTypes.UPDATE_FOCUSED_IDS,
    payload: ids,
});

export const updateLiveElementsPositions = (tableName) => ({
    type: diagramActionTypes.UPDATE_LIVE_ELEMENTS_POSITIONS,
    payload: tableName,
});
// 1. CONTROLS LEFT | NEW TABLE CLICK
export const enableBtnNewTableClick = () => ({
    type: diagramActionTypes.ENABLE_BTN_NEW_TABLE_CLICK,
});
export const disableBtnNewTableClick = () => ({
    type: diagramActionTypes.DISABLE_BTN_NEW_TABLE_CLICK,
});

// 2. CONTROLS LEFT | NEW TABLE GRAB
export const enableBtnNewTableGrab = () => ({
    type: diagramActionTypes.ENABLE_BTN_NEW_TABLE_GRAB,
});
export const disableBtnNewTableGrab = () => ({
    type: diagramActionTypes.DISABLE_BTN_NEW_TABLE_GRAB,
});

// 3. CONTROLS LEFT | NEW NOTE CLICK
export const enableBtnNewNoteClick = () => ({
    type: diagramActionTypes.ENABLE_BTN_NEW_NOTE_CLICK,
});
export const disableBtnNewNoteClick = () => ({
    type: diagramActionTypes.DISABLE_BTN_NEW_NOTE_CLICK,
});

// 4. CONTROLS LEFT | NEW NOTE GRAB
export const enableBtnNewNoteGrab = () => ({
    type: diagramActionTypes.ENABLE_BTN_NEW_NOTE_GRAB,
});
export const disableBtnNewNoteGrab = () => ({
    type: diagramActionTypes.DISABLE_BTN_NEW_NOTE_GRAB,
});

// 5. CONTROLS LEFT | NEW LINE
export const toggleBtnNewLine = () => ({
    type: diagramActionTypes.TOGGLE_BTN_NEW_LINE,
});

// 5. CONTROLS LEFT | NEW AREA
export const toggleBtnNewArea = (isKeyClick = false) => ({
    type: diagramActionTypes.TOGGLE_BTN_NEW_AREA,
    payload: {
        isKeyClick,
    },
});
export const disableBtnNewArea = () => ({
    type: diagramActionTypes.DISABLE_BTN_NEW_AREA,
});


// 5. CONTROLS LEFT | PEN
export const toggleBtnPen = () => ({
    type: diagramActionTypes.TOGGLE_BTN_PEN,
});

// 6. CONTROLS TOP | EXPORT
export const toggleBtnSettings = () => ({
    type: diagramActionTypes.TOGGLE_BTN_SETTINGS,
});

export const toggleBtnNewDiagram = () => ({
    type: diagramActionTypes.TOGGLE_BTN_NEW_DIAGRAM,
});

export const toggleBtnModalShortcuts = () => ({
    type: diagramActionTypes.TOGGLE_BTN_MODAL_SHORTCUTS,
});


// 6. CONTROLS TOP | PROFILE
export const toggleBtnProfile = () => ({
    type: diagramActionTypes.TOGGLE_BTN_PROFILE,
});



// 6. CONTROLS TOP | EXPORT
export const toggleBtnExport = () => ({
    type: diagramActionTypes.TOGGLE_BTN_EXPORT,
});
// 6. CONTROLS TOP | EXPORT
export const disableBtnExport = () => ({
    type: diagramActionTypes.DISABLE_BTN_EXPORT,
});

// 6. CONTROLS TOP | EXPORT IMAGE
export const toggleBtnExportImage = () => ({
    type: diagramActionTypes.TOGGLE_BTN_EXPORT_IMAGE,
});
// 6. CONTROLS TOP | EXPORT IMAGE
export const disableBtnExportImage = () => ({
    type: diagramActionTypes.DISABLE_BTN_EXPORT_IMAGE,
});

// 6. CONTROLS TOP | EXPORT CODE
export const toggleBtnExportCode = () => ({
    type: diagramActionTypes.TOGGLE_BTN_EXPORT_CODE,
});
// 6. CONTROLS TOP | EXPORT CODE
export const disableBtnExportCode = () => ({
    type: diagramActionTypes.DISABLE_BTN_EXPORT_CODE,
});

// 6. CONTROLS TOP | SQL SYNTAX
export const toggleBtnSqlSyntax = () => ({
    type: diagramActionTypes.TOGGLE_BTN_SQL_SYNTAX,
});
// 8. SQL SYNTAX
export const setSqlSyntax = (value) => ({
    type: diagramActionTypes.SET_SQL_SYNTAX,
    payload: {
        sqlSyntax: value,
    },
});

// 6. CONTROLS TOP | VIEW MODES
export const toggleBtnViewModes = () => ({
    type: diagramActionTypes.TOGGLE_BTN_VIEW_MODES,
});
// 6. CONTROLS TOP | VIEW MODES
export const disableBtnViewModes = () => ({
    type: diagramActionTypes.DISABLE_BTN_VIEW_MODES,
});

// 7. CONTROLS TOP | SEARCH
export const toggleBtnSearch = () => ({
    type: diagramActionTypes.TOGGLE_BTN_SEARCH,
});
export const disableBtnSearch = () => ({
    type: diagramActionTypes.DISABLE_BTN_SEARCH,
});
// Search spotlight hover: column to paint with the hover background on canvas.
// Payload: { elementId, columnId } | null. Never touches focusedInsideElement.
export const setSearchHoveredColumn = (value) => ({
    type: diagramActionTypes.SET_SEARCH_HOVERED_COLUMN,
    payload: value,
});
// 8. CONTROLS TOP | LEFT PANEL
export const toggleBtnLeftPanel = () => ({
    type: diagramActionTypes.TOGGLE_BTN_LEFT_PANEL,
});
// 8. CONTROLS TOP | EDIT NAME
export const toggleBtnEditName = () => ({
    type: diagramActionTypes.TOGGLE_BTN_EDIT_NAME,
});

export const disableBtnPopupNews = () => ({
    type: diagramActionTypes.DISABLE_BTN_POPUP_NEWS,
});

// 8. CONTROLS BOTTOM | MINIMAP
export const toggleBtnMinimap = () => ({
    type: diagramActionTypes.TOGGLE_BTN_MINIMAP,
});

// CONTROLS | FOCUS MODE (repurposed fullscreen button)
export const toggleControlsFocusMode = () => ({
    type: diagramActionTypes.TOGGLE_CONTROLS_FOCUS_MODE,
});
export const toggleTopControls = () => ({
    type: diagramActionTypes.TOGGLE_TOP_CONTROLS,
});
export const toggleLeftControls = () => ({
    type: diagramActionTypes.TOGGLE_LEFT_CONTROLS,
});

// 8. CONTROLS BOTTOM | INFORMATION & RESOURCES
export const toggleBtnInfoResources = () => ({
    type: diagramActionTypes.TOGGLE_BTN_INFO_RESOURCES,
});

// 8. CONTROLS TOP | RED GREEN VIEW
export const toggleBtnRedGreenView = () => ({
    type: diagramActionTypes.TOGGLE_BTN_RED_GREEN_VIEW,
});

// 8. VIEW MODE
export const setElementsViewMode = (value) => ({
    type: diagramActionTypes.SET_ELEMENTS_VIEW_MODE,
    payload: {
        viewMode: value,
    },
});

// 8. PEN MENU | COLOR
export const setNewPenColor = (value) => ({
    type: diagramActionTypes.SET_COLOR_NEW_PEN,
    payload: {
        color: value,
    },
});

// 8. PEN MENU | WIDTH
export const setNewPenWidth = (value) => ({
    type: diagramActionTypes.SET_WIDTH_NEW_PEN,
    payload: {
        width: value,
    },
});

// 8. PEN MENU | CLEAR
export const clearNewPen = () => ({
    type: diagramActionTypes.CLEAR_NEW_PEN,
});

export const updateScalePlus = () => ({
    type: diagramActionTypes.UPDATE_SCALE_PLUS,
});
export const updateScaleMinus = () => ({
    type: diagramActionTypes.UPDATE_SCALE_MINUS,
});
export const resetScale = () => ({
    type: diagramActionTypes.RESET_SCALE,
});

export const updateScale = (scale, x, y) => ({
    type: diagramActionTypes.UPDATE_SCALE,
    payload: { scale, x, y },
});
export const updateOriginXY = (x, y) => ({
    type: diagramActionTypes.UPDATE_ORIGIN_XY,
    payload: { x, y },
});
export const updateScaleToFit = () => ({
    type: diagramActionTypes.UPDATE_SCALE_TO_FIT,
});

// Dispatched by the onUpdateScaleToFit saga after computing limits from Yjs.
export const applyScaleToFit = (scale, x, y) => ({
    type: diagramActionTypes.APPLY_SCALE_TO_FIT,
    payload: { scale, x, y },
});

// Viewport tween frames (search preview/commit animation). Unlike
// APPLY_SCALE_TO_FIT this does NOT clear the selection — animation frames
// must not wipe a selection made at commit time.
export const applyViewport = (scale, x, y) => ({
    type: diagramActionTypes.APPLY_VIEWPORT,
    payload: { scale, x, y },
});

export const showContextMenu = () => ({
    type: diagramActionTypes.SHOW_CONTEXT_MENU,
});

export const hideContextMenu = () => ({
    type: diagramActionTypes.HIDE_CONTEXT_MENU,
});

export const toggleVisibilityContextMenu = () => ({
    type: diagramActionTypes.TOGGLE_VISIBILITY_CONTEXT_MENU,
});

export const focusOnColumnBelow = (tableId, columnId) => ({
    type: diagramActionTypes.FOCUS_ON_COLUMN_BELOW,
    payload: { tableId, columnId },
});
export const focusOnColumnAbove = (tableId, columnId) => ({
    type: diagramActionTypes.FOCUS_ON_COLUMN_ABOVE,
    payload: { tableId, columnId },
});

export const focusOnFirstColumn = (tableId) => ({
    type: diagramActionTypes.FOCUS_ON_FIRST_COLUMN,
    payload: { tableId },
});

export const clickEscape = () => ({
    type: diagramActionTypes.CLICK_ESCAPE,
});

export const setIsHistoryClicked = () => ({
    type: diagramActionTypes.SET_IS_HISTORY_CLICKED,
});

export const enableElementDescriptionEditing = () => ({
    type: diagramActionTypes.ENABLE_ELEMENT_DESCRIPTION_EDITING,
});

export const disableElementDescriptionEditing = () => ({
    type: diagramActionTypes.DISABLE_ELEMENT_DESCRIPTION_EDITING,
});

export const canvasStarted = () => ({
    type: diagramActionTypes.CANVAS_STARTED,
})
// export const moveToMain = () => ({
//     type: diagramActionTypes.MOVE_TO_MAIN,
// });













// FETCH DIAGRAM
// --------------------------------------------------------------
export const fetchDiagram = (diagramId) => ({
    type: diagramActionTypes.FETCH_DIAGRAM_REQUEST,
    payload: { diagramId },
})
export const fetchDiagramSuccess = (data) => ({
    type: diagramActionTypes.FETCH_DIAGRAM_SUCCESS,
    payload: { data },
})
export const fetchDiagramFailure = error => ({
    type: diagramActionTypes.FETCH_DIAGRAM_FAILURE,
    payload: error,
})



// PRICING PLAN LIMIT
// --------------------------------------------------------------
export const enableCanvasPricingPlanLimit = (type) => ({
    type: diagramActionTypes.ENABLE_CANVAS_MODAL_PRICING_PLAN_LIMIT,
    payload: type,
});
export const disableCanvasPricingPlanLimit = (type) => ({
    type: diagramActionTypes.DISABLE_CANVAS_MODAL_PRICING_PLAN_LIMIT,
    payload: type,
});
// export const togglePricingPlanUpgrade = () => ({
//     type: mainActionTypes.TOGGLE_MODAL_PRICING_PLAN_UPGRADE,
// });


// PRICING PLAN LIMIT MAX
// --------------------------------------------------------------
export const enableCanvasPricingPlanLimitMax = (type) => ({
    type: diagramActionTypes.ENABLE_CANVAS_MODAL_PRICING_PLAN_LIMIT_MAX,
    payload: type,
});
export const disableCanvasPricingPlanLimitMax = (type) => ({
    type: diagramActionTypes.DISABLE_CANVAS_MODAL_PRICING_PLAN_LIMIT_MAX,
    payload: type,
});

// // LOAD SAMPLE PROJECT DATA
// // --------------------------------------------------------------
// export const loadSampleProjectData = () => ({
//     type: diagramActionTypes.LOAD_SAMPLE_PROJECT_DATA,
// });

// MODAL DIAGRAM EXPORT SQL
// --------------------------------------------------------------
export const toggleModalDiagramExportSQL = (dbEngine) => ({
    type: diagramActionTypes.TOGGLE_MODAL_DIAGRAM_EXPORT_SQL,
    payload: { dbEngine },
});
export const disableModalDiagramExportSQL = () => ({
    type: diagramActionTypes.DISABLE_MODAL_DIAGRAM_EXPORT_SQL,
});

// FOCUS_ALL_ELEMENTS
// --------------------------------------------------------------
export const focusAllElements = () => ({
    type: diagramActionTypes.FOCUS_ALL_ELEMENTS,
});


// EXPORT IMAGE CLICK
// --------------------------------------------------------------
export const enableExportImageClick = () => ({
    type: diagramActionTypes.ENABLE_BTN_EXPORT_IMAGE_CLICK,
});
export const disableExportImageClick = () => ({
    type: diagramActionTypes.DISABLE_BTN_EXPORT_IMAGE_CLICK,
});


export const toggleBtnGridStyle = () => ({
    type: diagramActionTypes.TOGGLE_BTN_GRID_STYLE,
});

// --------------------------------------------------------------
export const clearDiagramDetails = () => ({
    type: diagramActionTypes.CLEAR_DIAGRAM_DETAILS,
});

export const setUndoState = ({ canUndo, canRedo }) => ({
    type: diagramActionTypes.SET_UNDO_STATE,
    payload: { canUndo, canRedo },
});

export const applyUserViewport = (viewport) => ({
    type: diagramActionTypes.APPLY_USER_VIEWPORT,
    payload: viewport,
});

export const saveUserViewport = () => ({
    type: diagramActionTypes.SAVE_USER_VIEWPORT,
});

